import type { AccountAddress } from '../../../types';
import type { ChainAssetBalance } from '../balance';

/**
 * Adds wallet IDs to the existing list if they don't already exist.
 * Includes all non-vault custodies (wallet, external-signer, multi-sig).
 */
export function addUniqueWalletIds(
  existingWalletIds: string[],
  newBalance: Pick<ChainAssetBalance, 'chain' | 'walletAddress'>,
  accountAddresses: AccountAddress[]
): string[] {
  const accountAddr = accountAddresses.find(
    (a) =>
      a.chain === newBalance.chain &&
      a.address === newBalance.walletAddress &&
      a.custody !== 'vault'
  );

  const walletId = accountAddr?.walletId;

  if (!walletId) {
    return existingWalletIds;
  }

  return existingWalletIds.includes(walletId)
    ? existingWalletIds
    : [...existingWalletIds, walletId];
}
